import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";
import { formatApiError } from "@/admin/AdminAuthContext";
import { PageHeader, LoadingRow, Drawer, Field, FieldTextarea } from "@/admin/pages/AdminSubsidiaries";

export default function AdminPages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.get("/admin/pages");
      setItems(data);
    } catch (err) { toast.error(formatApiError(err)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing) return;
    try {
      const { slug, id: _id, ...body } = editing;
      await adminApi.patch(`/admin/pages/${slug}`, body);
      toast.success("Saved.");
      setEditing(null);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="admin-pages-page">
      <PageHeader title="Pages (SEO & Content)" />
      {loading ? <LoadingRow /> : (
        <div className="bg-white border border-softgray divide-y divide-softgray">
          {items.map((p) => (
            <div key={p.slug} className="p-4 hover:bg-offwhite/70 flex items-center gap-4" data-testid={`page-row-${p.slug}`}>
              <div className="flex-1 min-w-0">
                <div className="text-navy font-serif truncate">{p.heading || p.slug}</div>
                <div className="text-mutedink text-xs mt-0.5">/{p.slug === "companies" ? "companies" : p.slug} — {p.seo_title}</div>
              </div>
              <button className="btn-outline-gold !py-1.5 !text-[10px]" onClick={() => setEditing(p)}>Edit</button>
            </div>
          ))}
          {items.length === 0 && <div className="p-6 text-mutedink text-sm text-center">No pages yet.</div>}
        </div>
      )}
      {editing && (
        <Drawer title={`Edit page: /${editing.slug}`}
                onClose={() => setEditing(null)} onSave={save} testId="page-drawer">
          <div className="grid gap-4">
            <Field label="SEO title" value={editing.seo_title}
                   onChange={(v) => setEditing({ ...editing, seo_title: v })} />
            <FieldTextarea label="SEO description" rows={3} value={editing.seo_description}
                           onChange={(v) => setEditing({ ...editing, seo_description: v })} />
            <Field label="Heading" value={editing.heading}
                   onChange={(v) => setEditing({ ...editing, heading: v })} />
            <FieldTextarea label="Subheading" rows={2} value={editing.subheading}
                           onChange={(v) => setEditing({ ...editing, subheading: v })} />
            <FieldTextarea label="Body" rows={12} value={editing.body}
                           onChange={(v) => setEditing({ ...editing, body: v })} />
          </div>
        </Drawer>
      )}
    </div>
  );
}
